'use strict';
import {MiscUtils} from './MiscUtils';
import {ngKeyEvents} from './ngKeyEvents';
import {ngApplyFocusDirective} from './ngApplyFocus';
const angular = require('angular');

const utilsModule = module.exports = angular
  .module('app.core-utilities.misc-utils', [])
  .service('$miscUtils', MiscUtils)
  .directive('ngApplyFocus', ngApplyFocusDirective);

ngKeyEvents(utilsModule);



// WEBPACK FOOTER //
// ./src/js/core-utilities/misc-utils/index.js